import { Task } from '../../services/todoApi';

export type DayTaskRow =
  | {
      mode: 'editing';
      task: Task;
    }
  | {
      mode: 'sortable';
      task: Task;
    };

export const buildDayTaskRows = (
  tasks: Task[],
  editingTaskId: string | null
): DayTaskRow[] =>
  tasks.map((task) => ({
    mode: task.id === editingTaskId ? 'editing' : 'sortable',
    task,
  }));

export const getSortableTaskIds = (rows: DayTaskRow[]): string[] =>
  rows
    .filter((row): row is Extract<DayTaskRow, { mode: 'sortable' }> => row.mode === 'sortable')
    .map((row) => row.task.id);
